export default {
  apiKey: 'AIzaSyABvAfdNrdRpTrBN5aUMcn22JsDtVxrVoE',
  authDomain: 'intrack-1240695-x.firebaseapp.com',
  databaseURL: 'https://intrack-1240695-x.firebaseio.com',
  projectId: 'intrack-1240695-x',
  storageBucket: 'intrack-1240695-x.appspot.com',
  messagingSenderId: '521939163729',
  appId: '1:521939163729:web:e1ae1016061cf1ad'
};
